import Openpay from './Openpay'

Vue.prototype.$state.$openpay = new Vue(Openpay)

Vue.component('openpay-card-web-payment-form', () => import(/* webpackChunkName: "openpay-card-web-payment-form" */ '@modulesPages/Openpay/Resources/assets/js/Forms/OpenpayCardWebPaymentForm'))
Vue.component('openpay-card-form', () => import(/* webpackChunkName: "openpay-card-form" */ '@modulesPages/Openpay/Resources/assets/js/Forms/OpenpayCardForm'))